import React from 'react';
import { Flex } from 'rebass';
import Styled from 'styled-components';
import { Body1 } from '../FontStyles';
import baseTheme from '../../themes/baseTheme';
import Button from './Button';
import NotificationListItem from './NotificationListItem';

const NotificationPanelCont = Styled(Flex)`
min-width: 350px;
max-width: 700px;

`;

const NotificationHeader = Styled(Flex)`
border-bottom: ${baseTheme.border};

`;

const NotificationList = Styled(Flex)`

`;

const SettingsButton = Styled(Button)`
padding: 0;
border: none;


`;

export default props => (
  <NotificationPanelCont flexWrap="wrap">
    <NotificationHeader px={3} alignItems="center" justifyContent="space-between" width={1}>
      <Body1> Notifications </Body1>
      <Flex>
        <SettingsButton className="outline">
          <i class="material-icons up">settings</i>
        </SettingsButton>
      </Flex>
    </NotificationHeader>
    <NotificationList flexWrap="wrap" width={1}>
      <NotificationListItem
        mainText="New message from Dr. Adi"
        secondaryText="You should modify your ISF based on...."
        timestamp="4:32 pm on 5/30"
      />
      <NotificationListItem
        mainText="New message from Dr. Adi"
        secondaryText="Are you sleeping?"
        timestamp="2:11 am on 4/28"
      />
    </NotificationList>
  </NotificationPanelCont>
);
